module.exports = __webpack_public_path__ + "img/back-icon.17fc53aa.svg";